import { useQuery } from '@apollo/client';
import {
  TagListFilterInput,
  TagsDocument,
} from 'src/graphql/generated/graphql';

const limit = 100;
const offset = 0;

export const useTags = ({ filter }: { filter?: TagListFilterInput }) => {
  const { data, loading } = useQuery(TagsDocument, {
    variables: {
      filter: filter,
      pagination: {
        limit,
        offset,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    tags: data?.tags?.records || [],
    loading,
  };
};
